import * as actionTypes from "../constants/actionTypes";

const initialState = {
  trendingTopics: [],
  getTrendingTopicsSuccess: false,
  getTrendingTopicsError: null,
  offset: false,
  colors: ["#e74e29", "#7d61e1", "#3faff3", "#a8947b"],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case (actionTypes.GET_TRENDING_TOPICS_SUCCESS): {
      return Object.assign({}, state, {
        trendingTopics: action.payload,
        getTrendingTopicsSuccess: true,
      });
    }

    case (actionTypes.GET_TRENDING_TOPICS_ERROR): {
      return Object.assign({}, state, {
        getTrendingTopicsSuccess: false,
        getTrendingTopicsError: action.payload,
      });
    }

    case (actionTypes.TOGGLE_OFFSET): {
      return Object.assign({}, state, {
        offset: action.payload,
      });
    }

    default: {
      return state;
    }
  }
};
